/* eslint-disable no-nested-ternary */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import { Box, TableCell, TableRow } from "@mui/material";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
// import * as Sentry from "@sentry/react";
import Typography from "../../../components/common/new/Typography/Typography";
import Male from "../../../assets/svg/Male";
import Female from "../../../assets/svg/Female";
import { getDirectAppointmentType, getGohonzonType } from "../../../utils";
import { selectUserProfile } from "../../../redux/selectors/user";
import EditIcon from "../../../assets/svg/Edit";
import Delete from "../../../assets/svg/Delete";
// import Member from "../../../services/api/member";
import { PERMISSIONS } from "../../../contants";
// import UpdateDirectExamEntryModal from "./Components/DirectExamEntry/UpdateDirectExamEntryModal";

const styles = {
  tableRowCell: {
    borderBottom: "1px solid #BFCFE1",
  },
  status: {
    backgroundColor: "#E8FFDB",
    border: "1px solid #1C9C29",
    borderRadius: 12,
    padding: "2px 12px",
  },
};

export const MAX_SIZE = 6;
export const ATTENDANCE_MAX_SIZE = 48;

export const TABLE_TYPE = {
  ALERT: "ALERT",
  EXAMINATION: "EXAMINATION",
  AWARDS: "AWARDS",
  SUBS: "SUBS",
  FAMILY: "FAMILY",
  APPOINTMENT: "APPOINTMENT",
  ATTENDANCE: "ATTENDANCE",
  REMARKS: "REMARKS",
  SPECIAL: "SPECIAL",
  GOHONZON: "GOHONZON",
  INPROGRESSAPPOINTMENT: "INPROGRESSAPPOINTMENT",
  PREVIOUSAPPOINTMENT: "PREVIOUSAPPOINTMENT",
  HDC: "HDC",
};
export const ROW_LIMIT = {
  [TABLE_TYPE.ALERT]: 3,
  [TABLE_TYPE.SUBS]: 3,
  [TABLE_TYPE.EXAMINATION]: 2,
  [TABLE_TYPE.AWARDS]: 2,
  [TABLE_TYPE.REMARKS]: 3,
  [TABLE_TYPE.FAMILY]: 3,
  [TABLE_TYPE.APPOINTMENT]: 3,
  [TABLE_TYPE.ATTENDANCE]: 12,
  [TABLE_TYPE.UIN]: 5,
  [TABLE_TYPE.SPECIAL]: 1,
  [TABLE_TYPE.PREVIOUSAPPOINTMENT]: 2,
  [TABLE_TYPE.INPROGRESSAPPOINTMENT]: 2,
  [TABLE_TYPE.GOHONZON]: 2,
  [TABLE_TYPE.HDC]: 3,
};

export const FLEX_CONTAINER = [TABLE_TYPE.ATTENDANCE];

export const getMaxRow = (data) =>
  Object.keys(data).reduce((acc, key) => {
    const { rows } = data[key];
    return rows.length > acc ? rows.length : acc;
  }, 0);

const MeetingTypesMap = {
  DISCUSSION_MEETING: "discussionMeeting",
  GOSHO_MEETING: "goshoMeeting",
  CUBS_MEETING: "cubMeeting",
  YP_MEETING: "YPMeeting",
  YL_MEETING: "YLMeeting",
  SD_MEETING: "SDMeeting",
  NHR_MEETING: "NHRMeeting",
};

export const getFormattedMembers = (data) => {
  if (!data || !data.length) return [];

  return data.map((item) => ({
    memberId: item?.memberId,
    name: item?.fullName,
    gender: item?.gender,
    areaId: item?.areaId,
    clusterId: item?.clusterId,
    zoneId: item?.zoneId,
    regionId: item?.regionId,
    chapterId: item?.chapterId,
    districtId: item?.districtId,
  }));
};

const getRowData = (curr) => {
  const date = moment(curr.meeting.meetingDate);
  return {
    id: curr.id,
    month: date.format("MMMM"),
    year: date.format("YYYY"),
  };
};

export const getFormattedData = (data) => {
  if (!data || !data.length) return {};

  return data.reduce(
    (acc, curr) => {
      const key = MeetingTypesMap[curr.meeting.meetingType];
      const currentRows = acc[key].rows;

      return {
        ...acc,
        [key]: {
          ...acc[key],
          rows: [...currentRows, getRowData(curr)],
        },
      };
    },
    {
      discussionMeeting: { title: "Discussion Meeting", rows: [] },
      goshoMeeting: { title: "Gosho Meeting", rows: [] },
      NHRMeeting: { title: "NHR Meeting", rows: [] },
      SDMeeting: { title: "Student Meeting", rows: [] },
      cubMeeting: { title: "Cub Meeting", rows: [] },
      YPMeeting: { title: "Young Pheonix Meeting", rows: [] },
      YLMeeting: { title: "Young Lion Meeting", rows: [] },
    }
  );
};

export const getFormattedAppointments = (data) => {
  if (!data || !data.length) return [];

  return data.map((item) => ({
    position: item.positionName,
    location: item.location,
    appointmentDate: item.appointedAt
      ? moment(item.appointedAt).format("DD/MM/YYYY")
      : null,
    mainline: getDirectAppointmentType(item.positionType),
    divisionName: item.divisionName,
    subdivisionName: item.subDivisionName,
    // item.positionType?.split("_")[0],
  }));
};

export const getFormattedPreviousAppointments = (data) => {
  if (!data || !data.length) return [];

  return data.map((item) => ({
    position: item.appliedForName,
    appointmentFromDate: item.createdAt
      ? moment(item.createdAt).format("DD/MM/YYYY")
      : null,
    appointmentToDate: item.deactivatedAt
      ? moment(item.deactivatedAt).format("DD/MM/YYYY")
      : null,
    mainLine: getDirectAppointmentType(item?.appointmentApplicationType),
    remark: item.remark,
  }));
};

export const getFormattedAllPreviousAppointments = (data) => {
  if (!data || !data.length) return [];

  return data.map((item) => ({
    position: item.appliedForName,
    divisionName: item.divisionName,
    subdivisionName: item.subdivisionName,
    location: item.location,
    appointmentFromDate: item.createdAt
      ? moment(item.createdAt).format("DD/MM/YYYY")
      : // : item.updatedAt
        // ? moment(item.updatedAt).format("DD/MM/YYYY")
        "NA",
    appointmentToDate: item.deactivatedAt
      ? moment(item.deactivatedAt).format("DD/MM/YYYY")
      : item?.updatedAt
      ? moment(item?.updatedAt).format("DD/MM/YYYY")
      : "NA",
    mainline: getDirectAppointmentType(item.appointmentApplicationType),
    orgStructure: [
      item?.currentAreaName,
      item?.currentclusterName,
      item?.currentZoneName,
      item?.currentRegionName,
      item?.currentChapterName,
      item?.currentDistrictName,
      item?.currentBlockName,
    ]
      .filter(Boolean)
      .join("/ "),
    remark: item.remark,
  }));
};

export const getFormattedGohonzon = (data) => {
  if (!data.gohonzonMemberships || !data.gohonzonMemberships.length) {
    return [];
  }
  const formattedData = data.gohonzonMemberships.map((item) => {
    return {
      type: getGohonzonType(item.type),
      createdAt: item.createdAt
        ? moment(item.createdAt).format("DD/MM/YYYY")
        : "Old Date",
      applicationId: item?.applicationId,
      memberId: item?.memberId,
      membername: item?.membername,
      applicationDate: item.applicationDate,
      conferredBy: item?.conferredBy,
      allotedAt: item?.allotedAt,
      allotedBy: item?.allotedBy,
    };
  });
  return formattedData;
};

export const getFormattedSubscription = (data) => {
  if (!data || !data.length) {
    return [];
  }
  const formattedData = data.map((item) => {
    return {
      type: item.type,
      date: item.endAt ? moment(item.endAt).format("DD/MM/YYYY") : "NA",
      status: item.subscriptionNumber,
    };
  });
  return formattedData;
};

export const getSubscriptionRows = (data, limit = ROW_LIMIT.SUBS) => {
  if (!data || data.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={4} align="center">
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return data?.slice(0, limit)?.map((subscription) => {
    return (
      <TableRow>
        <TableCell align="center" width="20%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {subscription.type === "FDT" ? "SS" : subscription.type}
          </Typography>
        </TableCell>
        <TableCell
          align="center"
          width="40%"
          style={{
            ...styles.tableRowCell,
            maxWidth: "80px",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          <Typography align="center" variant="mini" color="#000000">
            {subscription.status}
          </Typography>
        </TableCell>
        <TableCell align="center" width="20%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {subscription.date}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });
};

const handleDistrictSi = (user, familyMember, onSelectMember) => {
  if (user.districtSi && user.districtId === familyMember?.districtId) {
    onSelectMember(familyMember);
  }
};
const handleRegionSi = (user, familyMember, onSelectMember) => {
  if (user.regionSi && user.regionId === familyMember?.regionId) {
    onSelectMember(familyMember);
  }
};
const handleAreaSi = (user, familyMember, onSelectMember) => {
  if (user.areaSi && user.areaId === familyMember?.areaId) {
    onSelectMember(familyMember);
  }
};
const handleClusterSi = (user, familyMember, onSelectMember) => {
  if (user.clusterSi && user.clusterId === familyMember?.clusterId) {
    onSelectMember(familyMember);
  }
};
const handleZoneSi = (user, familyMember, onSelectMember) => {
  if (user.zoneSi && user.zoneId === familyMember?.zoneId) {
    onSelectMember(familyMember);
  }
};
const handleChapterSi = (user, familyMember, onSelectMember) => {
  if (user.chapterSi && user.chapterId === familyMember?.chapterId) {
    onSelectMember(familyMember);
  }
};

export const getFamilyMemberRows = (
  data,
  districtId,
  regionId,
  areaId,
  clusterId,
  zoneId,
  chapterId,
  onSelectMember,
  limit = ROW_LIMIT.FAMILY
) => {
  const user = useSelector(selectUserProfile);
  if (!data || data.length === 0) {
    return (
      <div style={{ margin: "auto", textAlign: "center", marginTop: "20px" }}>
        <Typography
          weight={600}
          style={{
            variant: "small",
            color: "#000000",
            padding: "4px",
          }}
        >
          No data available
        </Typography>
      </div>
    );
  }
  return data?.slice(0, limit)?.map((familyMember, index) => {
    return (
      <div
        style={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          alignItems: "center",
          gap: "2px",
          width: "100%",
          minWidth: "120px",
          height: "119px",
          borderLeft: index >= 1 ? "1px solid #BABABA" : "",
        }}
      >
        <Box>{familyMember.gender === "FEMALE" ? <Female /> : <Male />}</Box>

        <Typography
          noWrap
          fontWeight={600}
          color="#000000"
          style={{
            textAlign: "center",
            minWidth: "80px",
            width: "100%",
            whiteSpace: "initial",
            fontSize: "14px",
          }}
        >
          {familyMember?.name}
        </Typography>
        {user.helpDesk && (
          <Typography
            weight={600}
            variant="mini"
            color=" #043D90"
            onClick={() => {
              // handleDistrictSi(user, familyMember, onSelectMember);
              onSelectMember(familyMember);
            }}
            // style={
            //   user.districtId !== familyMember.districtId
            //     ? { cursor: "not-allowed", display: "flex" }
            //     : { cursor: "pointer", display: "flex" }
            // }
            style={{ cursor: "pointer", display: "flex" }}
          >
            <div style={{ color: "#000000", marginRight: "2px" }}>
              Member ID:{" "}
            </div>
            {familyMember.memberId}
          </Typography>
        )}
        {(user?.nationalLeader || user?.nationalSi) && (
          <Typography
            weight={600}
            variant="mini"
            color=" #043D90"
            onClick={() => {
              onSelectMember(familyMember);
            }}
            style={{ cursor: "pointer", display: "flex" }}
          >
            <div style={{ color: "#000000", marginRight: "2px" }}>
              Member ID:{" "}
            </div>
            {familyMember.memberId}
          </Typography>
        )}
        {user.districtSi && (
          <Typography
            weight={600}
            variant="mini"
            color=" #043D90"
            onClick={() => {
              handleDistrictSi(user, familyMember, onSelectMember);
            }}
            style={
              user.districtId !== familyMember.districtId
                ? { cursor: "not-allowed", display: "flex" }
                : { cursor: "pointer", display: "flex" }
            }
          >
            <div style={{ color: "#000000", marginRight: "2px" }}>
              Member ID:{" "}
            </div>
            {familyMember.memberId}
          </Typography>
        )}
        {user.regionSi && (
          <Typography
            weight={600}
            variant="mini"
            color=" #043D90"
            onClick={() => {
              handleRegionSi(user, familyMember, onSelectMember);
            }}
            style={
              user.regionId !== familyMember.regionId
                ? { cursor: "not-allowed", display: "flex" }
                : { cursor: "pointer", display: "flex" }
            }
          >
            <div style={{ color: "#000000", marginRight: "2px" }}>
              Member ID:{" "}
            </div>
            {familyMember.memberId}
          </Typography>
        )}
        {user.areaSi && (
          <Typography
            weight={600}
            variant="mini"
            color=" #043D90"
            onClick={() => {
              handleAreaSi(user, familyMember, onSelectMember);
            }}
            style={
              user.areaId !== familyMember.areaId
                ? { cursor: "not-allowed", display: "flex" }
                : { cursor: "pointer", display: "flex" }
            }
          >
            <div style={{ color: "#000000", marginRight: "2px" }}>
              Member ID:{" "}
            </div>
            {familyMember.memberId}
          </Typography>
        )}
        {user.clusterSi && (
          <Typography
            weight={600}
            variant="mini"
            color=" #043D90"
            onClick={() => {
              handleClusterSi(user, familyMember, onSelectMember);
            }}
            style={
              user.clusterId !== familyMember.clusterId
                ? { cursor: "not-allowed", display: "flex" }
                : { cursor: "pointer", display: "flex" }
            }
          >
            <div style={{ color: "#000000", marginRight: "2px" }}>
              Member ID:{" "}
            </div>
            {familyMember.memberId}
          </Typography>
        )}
        {user.zoneSi && (
          <Typography
            weight={600}
            variant="mini"
            color=" #043D90"
            onClick={() => {
              handleZoneSi(user, familyMember, onSelectMember);
            }}
            style={
              user.zoneId !== familyMember.zoneId
                ? { cursor: "not-allowed", display: "flex" }
                : { cursor: "pointer", display: "flex" }
            }
          >
            <div style={{ color: "#000000", marginRight: "2px" }}>
              Member ID:{" "}
            </div>
            {familyMember.memberId}
          </Typography>
        )}
        {user.chapterSi && (
          <Typography
            weight={600}
            variant="mini"
            color=" #043D90"
            onClick={() => {
              handleChapterSi(user, familyMember, onSelectMember);
            }}
            style={
              user.chapterId !== familyMember.chapterId
                ? { cursor: "not-allowed", display: "flex" }
                : { cursor: "pointer", display: "flex" }
            }
          >
            <div style={{ color: "#000000", marginRight: "2px" }}>
              Member ID:{" "}
            </div>
            {familyMember.memberId}
          </Typography>
        )}
      </div>
    );
  });
};

export const getAllFamilyMemberRows = (data, limit = ROW_LIMIT.FAMILY) => {
  return data?.slice(0, limit)?.map((familyMember, index) => {
    return (
      <TableRow>
        <TableCell style={styles.tableRowCell} align="left">
          {index + 1}
        </TableCell>
        <TableCell align="center" width="50%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {familyMember.name || "NA"}
          </Typography>
        </TableCell>
        <TableCell align="center" width="35%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {familyMember.memberId || "NA"}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });
};

const updateSubdivisionForGetAppointments = (name) => {
  if (
    name?.includes("Cubs Boys (class 1 to 4)") ||
    name?.includes("Cubs Girls (class 1 to 4)")
  ) {
    return "Cubs";
  }
  return name?.replace(/\([^)]*\)/g, "").trim();
};

export const getAppointmentRows = (data, limit = ROW_LIMIT.APPOINTMENT) => {
  if (!data || data.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={4} align="center" style={styles.tableRowCell}>
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return data.slice(0, limit).map((appointment) => {
    return (
      <TableRow>
        <TableCell align="center" width="15%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.position || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="15%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.mainline || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="15%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.divisionName || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="15%" style={styles.tableRowCell}>
          <Typography fontSize="14px" color="#000000">
            {updateSubdivisionForGetAppointments(
              appointment?.subdivisionName
            ) || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="15%" style={styles.tableRowCell}>
          {/* {!renderManageAccountsIcon && (
            <Typography variant="mini" color="#000000">
              {appointment.location || "NA"}
            </Typography>
          )} */}
          {appointment?.position !== "National Chief" && (
            <Typography variant="mini" color="#000000">
              {appointment.location || ""}
            </Typography>
          )}
          {/* <Typography variant="mini" color="#000000">
            {appointment.location || "NA"}
          </Typography> */}
        </TableCell>
        <TableCell align="center" width="15%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.appointmentDate || ""}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });
};

// Trim subdivision names and simplify "Cubs" categories and Remove values within parentheses and trim whitespace..
const updateSubdivision = (name) => {
  if (
    name?.includes("Cubs Boys (class 1 to 4)") ||
    name?.includes("Cubs Girls (class 1 to 4)")
  ) {
    return "Cubs";
  }
  return name?.replace(/\([^)]*\)/g, "").trim();
};

export const getAllAppointmentRows = (data) => {
  // const renderManageAccountsIcon = data?.some((position) => {
  //   const allowedPositionNames = [
  //     "National Chief",
  //     "National Chief - Deputy",
  //     "National Advisor",
  //     "National UHG Chief",
  //     "National UHG Chief - Deputy",
  //   ];
  //   return allowedPositionNames.includes(position.position);
  // });

  if (!data || data.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={4} align="center" style={styles.tableRowCell}>
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return data.slice(0).map((appointment) => {
    return (
      <TableRow>
        <TableCell align="center" width="25%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.position || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="40%" style={styles.tableRowCell}>
          <Typography fontSize="14px" color="#000000">
            {appointment.divisionName || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="40%" style={styles.tableRowCell}>
          <Typography fontSize="14px" color="#000000">
            {updateSubdivision(appointment?.subdivisionName) || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="25%" style={styles.tableRowCell}>
          {/* {!renderManageAccountsIcon && (
            <Typography variant="mini" color="#000000">
              {appointment.location || "NA"}
            </Typography>
          )} */}
          {appointment?.position !== "National Chief" && (
            <Typography variant="mini" color="#000000">
              {appointment.location || ""}
            </Typography>
          )}
        </TableCell>
        <TableCell align="center" width="25%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.appointmentDate || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="25%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.mainline || ""}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });
};

export const getPreviousAppointmentRows = (
  data,
  limit = ROW_LIMIT.PREVIOUSAPPOINTMENT
) => {
  if (!data || data.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={3} align="center">
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return data?.slice(0, limit)?.map((appointment) => {
    return (
      <TableRow>
        <TableCell align="center" width="20%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.position || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="20%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.mainLine || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="20%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.appointmentFromDate || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="20%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.appointmentToDate || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="20%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.remark || ""}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });
};

export const getAllPreviousAppointmentRows = (
  data
  // paginationInfo,
  // limit = ROW_LIMIT.PREVIOUSAPPOINTMENT
) => {
  // const renderManageAccountsIcon = memberInfo?.positions?.some((position) => {
  //   const allowedPositionNames = ["National Chief", ];
  //   return allowedPositionNames.includes(position.name);
  // });

  if (!data && data.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={3} align="center" rowSpan={5}>
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return data?.slice(0)?.map((appointment) => {
    // const serialNumber =
    //   index + 1 + paginationInfo.currentPage * paginationInfo.pageSize;
    return (
      <TableRow>
        {/* <TableCell style={styles.tableRowCell}>{index + 1}</TableCell> */}
        <TableCell align="center" width="30%" style={styles.tableRowCell}>
          <Typography weight={500} fontSize="14px" color="#000000">
            {appointment.position || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="40%" style={styles.tableRowCell}>
          <Typography fontSize="14px" color="#000000">
            {appointment.divisionName || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="40%" style={styles.tableRowCell}>
          <Typography fontSize="14px" color="#000000">
            {updateSubdivision(appointment?.subdivisionName) || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="40%" style={styles.tableRowCell}>
          <Typography fontSize="14px" color="#000000">
            {appointment.location || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="30%" style={styles.tableRowCell}>
          <Typography weight={500} fontSize="14px" color="#000000">
            {appointment.appointmentFromDate || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="40%" style={styles.tableRowCell}>
          <Typography fontSize="14px" color="#000000">
            {appointment.appointmentToDate || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="40%" style={styles.tableRowCell}>
          <Typography fontSize="14px" color="#000000">
            {appointment.mainline || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="40%" style={styles.tableRowCell}>
          <Typography fontSize="14px" color="#000000">
            {appointment.orgStructure || ""}
          </Typography>
        </TableCell>
        <TableCell align="center" width="40%" style={styles.tableRowCell}>
          <Typography fontSize="14px" color="#000000">
            {appointment.remark || ""}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });
};

export const getInprogressAppointmentRows = (
  data,
  limit = ROW_LIMIT.INPROGRESSAPPOINTMENT
) => {
  if (!data || !data.length) {
    return (
      <TableRow>
        <TableCell colSpan={4} align="center">
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return data?.slice(0, limit)?.map((appointment) => {
    return (
      <TableRow key={appointment.id}>
        <TableCell align="center" width="30%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.positionName || "NA"}
          </Typography>
        </TableCell>
        <TableCell align="center" width="40%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.appointedAt || "NA"}
          </Typography>
        </TableCell>
        <TableCell align="center" width="40%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {appointment.positionType || "NA"}
          </Typography>
        </TableCell>
        <TableCell align="center" width="30%" style={styles.tableRowCell}>
          <Typography
            weight={500}
            variant="mini"
            color="#ffffff"
            style={{
              backgroundColor: "rgb(255,155,0)",
              padding: "5px 10px",
            }}
          >
            {appointment.status || "NA"}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });
};

export const getAttendanceRows = (data, limit = ROW_LIMIT.ATTENDANCE) => {
  if (!data || !data.length) {
    return (
      <TableRow>
        <TableCell colSpan={4} align="center">
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }
  return data?.slice(0, limit)?.map((attendance) => {
    return (
      <TableRow>
        <TableCell width="50%" style={styles.tableRowCell}>
          <Typography fontSize="14px" color="#000000">
            {attendance.month}
          </Typography>
        </TableCell>
        <TableCell align="center" width="50%" style={styles.tableRowCell}>
          <Typography fontSize="14px" color="#000000">
            {attendance.year}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });
};

export const getUINRows = (data, limit = ROW_LIMIT.UIN) =>
  data?.slice(0, limit)?.map((uin) => {
    return (
      <TableRow>
        <TableCell
          width="20%"
          style={{ ...styles.tableRowCell, paddingLeft: "8px" }}
        >
          <Typography variant="mini" color="#8C8C8C">
            {uin.no}
          </Typography>
        </TableCell>
        <TableCell
          width="40%"
          style={{ ...styles.tableRowCell, paddingLeft: "8px" }}
        >
          <Typography variant="mini" color="#66697A">
            {uin.type}
          </Typography>
        </TableCell>
        <TableCell
          width="30%"
          style={{ ...styles.tableRowCell, paddingLeft: "8px" }}
        >
          <Typography variant="mini" color="#66697A">
            {uin.uinno}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });

export const getFormattedSpecial = (data) => {
  if (!data || !data.length) return [];

  return data.map((item) => ({
    name: item.specialGroupName,
    inductionDate: item.inductionDate
      ? moment(item.inductionDate).format("DD/MM/YYYY")
      : "NA",
    graduationDate: item.graduationDate
      ? moment(item.graduationDate).format("DD/MM/YYYY")
      : "NA",
  }));
};

export const getSpecialGroupRows = (data, limit = ROW_LIMIT.SPECIAL) => {
  if (!data || data.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={4} align="center">
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return data.slice(0, limit).map((special) => {
    return (
      <TableRow>
        <TableCell
          align="center"
          style={{
            ...styles.tableRowCell,
            maxWidth: "120px",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          <Typography noWrap variant="mini" color="#8C8C8C">
            {special.name}
          </Typography>
        </TableCell>
        <TableCell align="center" style={styles.tableRowCell}>
          <Typography variant="mini" color="#66697A">
            {special.inductionDate}
          </Typography>
        </TableCell>
        <TableCell align="center" style={styles.tableRowCell}>
          <Typography variant="mini" color="#66697A">
            {special.graduationDate}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });
};

export const getGohonzonMemberRows = (
  data,
  hasPermission,
  isHelpDesk,
  isHelpDeskAdmin,
  onGohonzonEditClick,
  onGohonzonDeleteClick,
  limit = ROW_LIMIT.GOHONZON
) => {
  if (!data || data.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={4} align="center">
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return data.slice(0, limit).map((gohonzonMember) => {
    const createdAtDate = new Date(
      gohonzonMember.createdAt.split("/").reverse().join("-")
    );
    return (
      <TableRow>
        <TableCell
          align="left"
          style={{
            ...styles.tableRowCell,
            maxWidth: "120px",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          <Typography noWrap variant="mini" color="#8C8C8C">
            {gohonzonMember.type}
          </Typography>
        </TableCell>
        <TableCell align="center" style={styles.tableRowCell}>
          <Typography variant="mini" color="#66697A">
            {createdAtDate < new Date("2001-01-01")
              ? "Old Data"
              : gohonzonMember.createdAt}
          </Typography>
        </TableCell>
        {hasPermission(PERMISSIONS.UPDATE_GOHONZON_APPLICATION) && (
          <TableCell align="center" width="20%" style={styles.tableRowCell}>
            <div
              style={{
                display: "flex",
                gap: "5px",
                justifyContent: "center",
              }}
            >
              {hasPermission(PERMISSIONS.UPDATE_GOHONZON_APPLICATION) && (
                <EditIcon
                  style={{ ...styles.icon, cursor: "pointer" }}
                  onClick={() => onGohonzonEditClick(gohonzonMember)}
                />
              )}

              {hasPermission(PERMISSIONS.REMOVE_EXAMINATION_APPLIED_MEMBERS) &&
                (isHelpDesk || isHelpDeskAdmin) && (
                  <Delete
                    style={{ ...styles.icon, cursor: "pointer" }}
                    onClick={() => onGohonzonDeleteClick(gohonzonMember)}
                  />
                )}
            </div>
          </TableCell>
        )}
      </TableRow>
    );
  });
};

export const getFormattedExam = (data) => {
  if (!data || !data.length) {
    return [];
  }
  const formattedData = data.map((item) => {
    const monthName = item.examDate
      ? moment(item.examDate).format("MMMM")
      : "NA";
    return {
      name: item.examName,
      month: monthName,
      year: item.examDate ? moment(item.examDate).format("YYYY") : "NA",
      examId: item?.examId,
      memberId: item?.member?.memberId,
      fullName: item?.member?.fullName,
      examDate: item?.examDate,
      examLevel: item?.examName,
      rollNumber: item?.rollNumber,
      remark: item?.remark,
    };
  });
  return formattedData;
};

export const getExamRows = (
  data,
  hasPermission,
  onDeleteClick,
  onEditClick,
  limit = ROW_LIMIT.EXAMINATION
) => {
  if (!data || data?.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={4} align="center">
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return data?.slice(0, limit)?.map((exam) => {
    return (
      <>
        <TableRow>
          <TableCell align="center" width="20%" style={styles.tableRowCell}>
            <Typography variant="mini" color="#000000">
              {exam.name}
            </Typography>
          </TableCell>
          <TableCell
            align="center"
            width="40%"
            style={{
              ...styles.tableRowCell,
              maxWidth: "80px",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            <Typography align="center" variant="mini" color="#000000">
              {exam.month}
            </Typography>
          </TableCell>
          <TableCell align="center" width="20%" style={styles.tableRowCell}>
            <Typography variant="mini" color="#000000">
              {exam.year}
            </Typography>
          </TableCell>
          {(hasPermission(PERMISSIONS.UPDATE_EXAMINATION_APPLIED_MEMBERS) ||
            hasPermission(PERMISSIONS.REMOVE_EXAMINATION_APPLIED_MEMBERS)) && (
            <TableCell align="center" width="20%" style={styles.tableRowCell}>
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  justifyContent: "center",
                }}
              >
                {hasPermission(
                  PERMISSIONS.UPDATE_EXAMINATION_APPLIED_MEMBERS
                ) && (
                  <EditIcon
                    style={{ ...styles.icon, cursor: "pointer" }}
                    onClick={() => onEditClick(exam)}
                  />
                )}
                {hasPermission(
                  PERMISSIONS.REMOVE_EXAMINATION_APPLIED_MEMBERS
                ) && (
                  <Delete
                    style={{ ...styles.icon, cursor: "pointer" }}
                    onClick={() =>
                      onDeleteClick(
                        {
                          memberId: exam.memberId,
                          applicationId: exam.examId,
                          examDate: exam.examDate || null,
                          examLevel: exam.examLevel || null,
                          rollNumber: exam.rollNumber || null,
                          remark: exam.remark || null,
                        }
                        // toast
                      )
                    }
                  />
                )}
              </div>
            </TableCell>
          )}
        </TableRow>
        {/* <UpdateDirectExamEntryModal
          open={directExamEntryModal}
          onClose={() => toggleDirectExamEntry()}
          exam={selectedExam}
        /> */}
      </>
    );
  });
};

export const getFormattedAward = (data) => {
  if (!data || !data.length) {
    return [];
  }
  const formattedData = data.map((item) => {
    return {
      name: item.awardName,
      date: item.awardDate ? moment(item.awardDate).format("MM/YYYY") : "NA",
      for: item.awardFor,
    };
  });
  return formattedData;
};

export const getAwardRows = (data, limit = ROW_LIMIT.AWARDS) => {
  if (!data || data.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={4} align="center">
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return data?.slice(0, limit)?.map((award) => {
    return (
      <TableRow>
        <TableCell align="center" width="20%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {award.name}
          </Typography>
        </TableCell>
        <TableCell
          align="center"
          width="40%"
          style={{
            ...styles.tableRowCell,
            maxWidth: "80px",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          <Typography align="center" variant="mini" color="#000000">
            {award.for}
          </Typography>
        </TableCell>
        <TableCell align="center" width="20%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {award.date}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });
};

export const getFormattedHdc = (data) => {
  if (!data.honoraryStructures || !data.honoraryStructures.length) {
    return [];
  }
  const formattedData = data.honoraryStructures.map((item) => {
    return {
      assignedAt: item.assignedAt
        ? moment(item.assignedAt).format("DD/MM/YYYY")
        : "NA",
      assignedBy: item.assignedBy.fullName,
      orgStructure: [
        item?.areaName,
        item?.clusterName,
        item?.zoneName,
        item?.regionName,
        item?.chapterName,
        item?.districtName,
      ]
        .filter(Boolean)
        .join("/ "),
    };
  });
  return formattedData;
};

const getRows = (data) => {
  if (!data || data.length === 0) {
    return data;
  }
  const newData = data.split("/");

  return newData.map((hdc, i) => {
    return (
      <span
        style={
          i === newData.length - 1
            ? { color: "#143786", fontWeight: 600, fontSize: "14px" }
            : null
        }
      >
        {hdc}
        <span>{i === newData.length - 1 ? null : "/"}</span>
      </span>
    );
  });
};

export const getHdcRows = (data) => {
  if (!data || data.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={3} align="center" style={styles.tableRowCell}>
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return data.slice(0).map((hdc) => {
    return (
      <TableRow>
        <TableCell align="center" width="25%" style={styles.tableRowCell}>
          <Box variant="mini" color="#000000">
            {/* {hdc.orgStructure || "NA"} */}
            {getRows(hdc.orgStructure || "NA")}
          </Box>
        </TableCell>
        <TableCell align="center" width="25%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {hdc.assignedAt || "NA"}
          </Typography>
        </TableCell>
        <TableCell align="center" width="25%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {hdc.assignedBy || "NA"}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });
};

export function getInitials(name) {
  if (typeof name !== "string") {
    return "";
  }

  const initials = name
    .split(" ")
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();

  return initials;
}
